import React from "react";
import "./Home.css";
import Header from "./Header/Header";
import Profile from "./Profile/Profile";
import Footer from "./Footer/Footer";
import BackgroundSlideshow from "./Background/BackgroundSlideshow";

export default function Home() {
  
  return (
    // <div className="home-container">
    //   <div className="home-parent-header">
    //     <Header></Header>
    //   </div>
    //   <Profile></Profile>
    //   <Footer></Footer>
    // </div>
    <div className="home-container">
      <BackgroundSlideshow />
      <div className="home-content">
        <div className="home-parent-header">
          <Header />
        </div>
        <Profile />
        <Footer />
      </div>
    </div>
  );
}
